<template>
  <AbstractTask :event="event" :action="action" @open-edit-component="show">
    <template #leadingHeaderAdditions><IdeaBadge :task-meta="action.meta" /></template>
    <template #description> {{ t("views.TaskBoard.idea.descriptionManage") }} </template>
    <template #oneLineContent>
      {{ t("views.TaskBoard.idea.descriptionManage") }}
    </template>
    <template #editComponent>
      <UpdateTaskModal
        v-model:visible-action-modal="actionModalVisible"
        :task="{ ...action, fileIds: action.Folder?.files.map((file) => file.id) ?? [] }"
        :event="event"
      />
    </template>
  </AbstractTask>
</template>

<script lang="ts">
import { useTranslation } from "@/language/translation";

import { defineComponent, type PropType, ref, provide } from "vue";
import AbstractTask from "@/components/event-action/task/AbstractTask.vue";
import UpdateTaskModal from "@/components/event-action/task/modal/UpdateTaskModal.vue";
import IdeaBadge from "./IdeaBadge.vue";
import type { ActionListActionFields_Task_Fragment, EventListEventFieldsFragment } from "@/graphql";
import {
  CommentUserIdInjectionKey,
  CommonTaskAdditionalComment,
} from "@/views/event-action/EventActionBoardInjectionKeys";

export default defineComponent({
  name: "IdeaManageTask",
  components: {
    AbstractTask,
    UpdateTaskModal,
    IdeaBadge,
  },
  props: {
    action: {
      type: Object as PropType<ActionListActionFields_Task_Fragment>,
      required: true,
    },
    event: {
      type: Object as PropType<EventListEventFieldsFragment>,
      required: true,
    },
  },
  setup() {
    const { t } = useTranslation();
    provide(CommonTaskAdditionalComment, ref<null>(null));

    const actionModalVisible = ref(false);
    const show = () => {
      actionModalVisible.value = true;
    };

    const commentUserId = ref<number>();
    provide(CommentUserIdInjectionKey, commentUserId);
    return {
      t,
      actionModalVisible,
      show,
    };
  },
});
</script>
<style lang="scss" scoped></style>
